import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function CircleDiagram({ values }: DiagramProps) {
  const r = Math.max(1, values.r ?? 5);
  const fn = Math.max(3, values.fn ?? 30);

  const cx = 100, cy = 75;
  const displayR = Math.min(58, Math.max(12, (r / 20) * 55));

  // $fn arc
  const segAngle = (2 * Math.PI) / fn;
  const arcEndAngle = segAngle * 2;
  const ax1 = cx + displayR;
  const ay1 = cy;
  const ax2 = cx + displayR * Math.cos(arcEndAngle);
  const ay2 = cy + displayR * Math.sin(arcEndAngle);
  const largeArc = arcEndAngle > Math.PI ? 1 : 0;

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Circle diagram">
      <defs>
        <marker id="arr-ci" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
          <path d="M0,1 L5,3 L0,5 Z" fill={D.DIM_STROKE} />
        </marker>
      </defs>

      {/* 2D label */}
      <text x="18" y="18" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.35">[2D shape]</text>

      {/* Circle */}
      <circle cx={cx} cy={cy} r={displayR} fill={D.GEO_FILL} stroke={D.GEO_STROKE} strokeWidth="1.5" />

      {/* Radius line */}
      <line x1={cx} y1={cy} x2={cx + displayR} y2={cy}
            stroke={D.DIM_STROKE} strokeWidth="1" strokeDasharray={D.DIM_DASH}
            markerEnd="url(#arr-ci)" />
      <text x={cx + displayR / 2} y={cy - 6} fontSize="10" fontFamily="monospace"
            fill={D.DIM_STROKE} textAnchor="middle" opacity="0.9">r = {r}</text>

      {/* Center dot */}
      <circle cx={cx} cy={cy} r="2.5" fill={D.ORIGIN_COLOR} />

      {/* $fn arc */}
      <path d={`M${ax1},${ay1} A${displayR},${displayR} 0 ${largeArc},1 ${ax2},${ay2}`}
            fill="none" stroke={D.X_COLOR} strokeWidth="2.5" opacity="0.8" />
      <text x={cx + displayR + 14} y={cy + 6} fontSize="9" fontFamily="monospace"
            fill={D.X_COLOR} opacity="0.85">$fn={fn}</text>

      {/* Info */}
      <text x="195" y="110" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4">r  = radius</text>
      <text x="195" y="122" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4">$fn = segments</text>
    </svg>
  );
}
